module.exports = __webpack_public_path__ + "static/iPhone8-Portrait-SpaceGray-de8f5b61939f103e53051b90708993f2.png";